import React from 'react';

const CheckoutSectionContent = ({ children, className }) => (
  <div className={`checkout__section-content ${className ? className : ''}`}>
    {children}
  </div>
);

export default CheckoutSectionContent;
